import React from 'react';
import { Modal, Form, Input, Select, Space, Avatar, Tag, FormInstance } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { CharacterStateRow } from './types';

const { TextArea } = Input;
const { Option } = Select;

interface SampleScenarioModalProps {
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
  confirmLoading: boolean;
  form: FormInstance;
  characterStatesData: any[]; // Use any[] for now, will refine types
}

const SampleScenarioModal: React.FC<SampleScenarioModalProps> = ({
  open,
  onOk,
  onCancel,
  confirmLoading,
  form,
  characterStatesData,
}) => {
  return (
    <Modal
      title="Tạo Sample Scenario bằng AI"
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      confirmLoading={confirmLoading}
      width={600}
      okText="Tạo Sample"
      cancelText="Hủy"
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Form.Item
          name="directive"
          label="Mô tả scenario muốn tạo"
          rules={[{ required: true, message: 'Vui lòng nhập mô tả scenario' }]}
        >
          <TextArea 
            rows={3} 
            placeholder="VD: Một cuộc đối thoại căng thẳng tại quán cà phê giữa hai bạn cùng phòng về việc mượn đồ không xin phép..."
          />
        </Form.Item>

        <Form.Item
          name="characterStateIds"
          label="Chọn Character States tham gia"
          rules={[{ required: true, message: 'Vui lòng chọn ít nhất 1 character state' }]}
        >
          <Select
            mode="multiple"
            placeholder="Chọn các character states"
            style={{ width: '100%' }}
          >
            {characterStatesData.map(stateRow => (
              <Option key={stateRow.stateId} value={stateRow.stateId}>
                <Space>
                  <Avatar src={stateRow.characterAvatar} icon={<UserOutlined />} size="small" />
                  <span>{stateRow.characterName}</span>
                  <span>- {stateRow.stateName}</span>
                  <Tag color={stateRow.characterType === 'main' ? 'gold' : 'blue'}>
                    {stateRow.characterType === 'main' ? 'MAIN' : 'NPC'}
                  </Tag>
                </Space>
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SampleScenarioModal;
